import { topicsData } from '@/mocks/home';

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12 max-w-xl mx-auto">
          按类型快速发现你感兴趣的电影和剧集分类
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <div
              key={topic.id}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-colors bg-background-50 border-background-200/60 hover:border-primary-300/60"
            >
              {topic.hot && (
                <span className="flex items-center gap-0.5 text-accent-500">
                  <i className="ri-fire-line text-xs w-3 h-3 flex items-center justify-center"></i>
                </span>
              )}
              <span className="text-sm text-foreground-800 font-medium whitespace-nowrap">{topic.label}</span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}